import { render } from "./InventoryProductItemsTableCard.vue?vue&type=template&id=4af2f704&scoped=true"
import script from "./InventoryProductItemsTableCard.vue?vue&type=script&lang=js"
export * from "./InventoryProductItemsTableCard.vue?vue&type=script&lang=js"

import "./InventoryProductItemsTableCard.vue?vue&type=style&index=0&id=4af2f704&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af2f704"]])

export default __exports__